export const Heading = require('./heading').default,
  Footer = require('./footer').default,
  Body = require('./body').default;
